import { createAction } from '@ngrx/store';

export const enum GrowthbookActionTypes {
  growthbookFeatureLoaded = '[app] GROWTHBOOK_FEATURE_LOADED'
}
export const growthbookFeatureLoaded = createAction(GrowthbookActionTypes.growthbookFeatureLoaded);